import React from 'react';
import {
  COLOR_LIGHT_GRAY,
  CUSTOMER_CANCEL_PHASE_CONTACTING,
  DARK_GRAY,
  ORDER_PHASE,
  SHOP_CANCEL_AND_REFUND,
  SHOP_CANCEL_PHASE_CONTACTING,
} from '../../../constants';

export default function OrderStatusIndicator({ order }) {
  const getBackgroundColor = () => {
    return COLOR_LIGHT_GRAY;
  };

  const getTextColor = () => {
    return DARK_GRAY;
  };

  const getOrderStatusLabel = () => {
    if (order.status === ORDER_PHASE.COMPLETED) return 'Terminée';
    if (
      [
        SHOP_CANCEL_AND_REFUND,
        SHOP_CANCEL_PHASE_CONTACTING,
        CUSTOMER_CANCEL_PHASE_CONTACTING,
      ].includes(order?.cancellation?.cancelReason) || order.status === ORDER_PHASE.REFUND
    )
      return 'Remboursée';
    return 'Annulée';
  };

  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: getBackgroundColor(),
        color: getTextColor(),
        padding: '2px 10px',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        columnGap: 10,
        top: 15,
        right: 20,
      }}
    >
      <div
        style={{
          backgroundColor: getTextColor(),
          padding: '2px 2px',
          borderRadius: 90,
        }}
      />
      <div>{getOrderStatusLabel()}</div>
    </div>
  );
}
